var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 286.25 194.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #eda30f;\n      }\n\n      .cls-2 {\n        fill: #18196d;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M192.97,101.97l-16.27,92.13h60.06l21.22-120.02-65.01,27.89ZM210.98,0l-7.99,45.25,62.69-14.76,5.39-30.49h-60.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M47.09,0l-21.63,122.45,64.77-26.54L107.18,0h-60.09ZM17.84,165.64l-5.03,28.46h60.06l7.35-41.58-62.38,13.12Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "286.25 44.53 261.31 55.23 196.3 83.13 152.88 101.76 161.58 119.06 83.22 135.55 20.83 148.67 1.16 152.81 0 150.17 22.17 141.09 86.93 114.55 127.41 97.97 119.78 81.26 199.96 62.39 262.65 47.64 285.13 42.35 286.25 44.53"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.0cedcf7156678a086b05e511d2c9e314.svg";
export { ForwardRef as ReactComponent };